import { BaseDto } from './base.dto';
import { StockCategoryDto } from './stockCategory.dto';
import { VATRateDto } from './vat-rate.dto';

export class PoSystemOrderItemDto extends BaseDto {
  poSystemOrderId: number;
  name: string;
  stockCategory: StockCategoryDto;
  nominalCode: string;
  price: number;
  quantity: number;
  vat: VATRateDto;
  vatAmount: number;
  itemSubTotal: number;
}